import { $fetch, type FetchOptions } from "ofetch"

import Resources from "@/api/resources"

export default defineNuxtPlugin((nuxtApp) => {
  const { callHook } = useNuxtApp()
  const { api } = useRuntimeConfig().public

  const fecther = $fetch.create({
    baseURL: api.url,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",

      ...api?.customHeaders
    },
    onRequest: async (props: object) => await callHook("api:request" as any, props),
    onResponse: async (props: object) => await callHook("api:response" as any, props),
    onRequestError: async (props: object) => await callHook("api:request:error" as any, props),
    onResponseError: async (props: object) => await callHook("api:response:error" as any, props)
  })

  globalThis.$api = Resources(fecther)

  return {
    provide: {
      api: globalThis.$api
    }
  }
})
